import { Navigate, useRoutes } from 'react-router-dom';
import { accountRoutes } from '@/apps/account/router';
import { adminTraceRoutes } from '@/apps/admin-trace/router';
import { adminRoutes } from '@/apps/admin/router';
import { agentsChatRoutes } from '@/apps/agents-chat/router';
import { authLayoutRoutes, authProtectedRoutes, authPublicRoutes } from '@/apps/auth/router';
import { traceRoutes } from '@/apps/trace/router';
import { ipCreatorRoutes } from '@/apps/ip-creator/router';
import { harnessRoutes } from '@/apps/harness/router';
import { settingsRoutes } from '@/apps/settings/router';
import { workplaceRoutes } from '@/apps/workplace/router';
import AuthGuard from '@/common/components/AuthGuard';
import OrganizationGuard from '@/common/components/OrganizationGuard';
import PlatformAdminGuard from '@/common/components/PlatformAdminGuard';
import AppLayout from '@/common/layouts/AppLayout';
import PublicLayout from '@/common/layouts/PublicLayout';
import Page404 from '@/common/views/Page404';

const appModuleRoutes = [
  ...agentsChatRoutes,
  ...workplaceRoutes,
  ...harnessRoutes,
  ...traceRoutes,
  ...ipCreatorRoutes,
  ...accountRoutes,
  ...settingsRoutes,
];

const defaultAppPath = appModuleRoutes.find((route) => route.path)?.path;

const appShellRoutes = [
  ...appModuleRoutes,
  {
    index: true,
    element: <Navigate to={defaultAppPath} replace />,
  },
  {
    path: '*',
    element: <Page404 />,
  },
];

const routes = [
  {
    element: <PublicLayout routes={authLayoutRoutes} />,
    children: [
      ...authPublicRoutes,
      {
        element: <AuthGuard />,
        children: authProtectedRoutes,
      },
    ],
  },
  {
    element: <AuthGuard />,
    children: [
      {
        element: <PlatformAdminGuard />,
        children: [
          {
            element: <AppLayout routes={[...adminRoutes, ...adminTraceRoutes]} />,
            children: [...adminRoutes, ...adminTraceRoutes],
          },
        ],
      },
    ],
  },
  {
    path: '/:organizationId',
    element: <AuthGuard />,
    children: [
      {
        element: <OrganizationGuard />,
        children: [
          {
            element: <AppLayout routes={appShellRoutes} />,
            children: appShellRoutes,
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <Page404 />,
  },
];

const AppRouter = () => {
  return useRoutes(routes);
};

export default AppRouter;
